export default __webpack_public_path__ + "assets/icons/iconRight.80ffdf11.svg";